<template>
  <div
    id="element"
    class="referral-container"
  >
    <div class="referral-container--item ">
      <Header/>
    </div>
    <div class="section-gray">
      <div class="breadcrumb-level">
        <div
          v-for="(value, index) in 3"
          :key="value"
          :class="['pointer', {'active': userReferrals.length > index * 10 }]"
        >
          <span class="lv-label">{{ $t('referral_program.level') }} {{ value }} </span>
          <span class="lv-receive">{{ inviteEachLevels(value, index) }}</span>
        </div>
      </div>
      <div class="title referral">
        {{ $t('referral_program.referral_program') }}
      </div>
      <div class="section-white">
        <div class="content">
          <div class="sub-title">
            {{ $t('referral_program.your_referral_link') }}
          </div>
          <div class="columns is-variable is-8-desktop">
            <div class="column is-one-third qr-code">
              <p class="subtitle" >{{ $t('referral_program.qr_code') }}</p>
              <div class="image">
                <vue-qr
                  v-if="!isLoadingUserData"
                  :dot-scale="1"
                  :size="200"
                  :margin="10"
                  :correct-level="0"
                  :logo-src="`/static/img/logo-referral-qr-code.png`"
                  :logo-scale="0.25"
                  :logo-margin="5"
                  :text="urlReferralLink"
                  :callback="getImageUrl"
                />
                <b-skeleton
                  v-else
                  width="190px"
                  height="190px"
                />
              </div>
              <div v-if="!isLoadingUserData">
                <span
                  v-if="!isIOS()"
                  class="download"
                  @click="saveAs(imageUrl, qrCodeFileName)"
                >
                  {{ $t('referral_program.download_qr') }}
                </span>
                <span
                  v-else
                  class="download"
                >
                  {{ $t('referral_program.press_and_hold') }}
                </span>
              </div>
              <span
                v-else
                class="download"
              >
                <b-skeleton/>
              </span>
            </div>
            <div
              id="referral-program-field"
              class="column share-social"
            >
              <p class="subtitle">{{ $t('referral_program.share_social') }}</p>
              <div
                v-if="!isLoadingUserData"
                class="social-wrapper"
              >
                <ShareToSocials :url="urlReferralLink"/>
              </div>
              <div
                v-else
                class="social-wrapper-skt"
              >
                <div class="level is-mobile">
                  <div class="level-left level-expand-on-mobile">
                    <div
                      v-for="(index) in 3"
                      :key="index"
                      class="level-item"
                    >
                      <b-skeleton
                        width="50px"
                        height="50px"
                        circle
                      />
                    </div>
                  </div>
                </div>
              </div>
              <p class="subtitle ref">{{ $t('referral_program.url_referral') }}</p>
              <p
                v-if="!isLoadingUserData"
                class="ref-url"
              >
                <b-input
                  :value="urlReferralLink"
                  class="is-underline-input-white is-underline-input-gray show-link"
                  name="referral link"
                  type="text"
                  readonly
                />
                <b-icon
                  v-clipboard:copy="urlReferralLink"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onCanNotCopy"
                  icon="content-copy"
                  class="copy-icon"
                />
              </p>
              <p v-else>
                <b-skeleton width="70%"/>
              </p>
            </div>
          </div>
        </div>
        <div id="section-referral-data"/>
        <div v-if="!isLoadingReferral">
          <div
            v-for="(lvValue, lvIndex) in amountOfLevels"
            :key="lvIndex"
          >
            <div class="level-header">
              <span class="lv-label">Level {{ lvValue }}</span>
              <span class="lv-receive">{{ inviteEachLevels(lvValue, lvIndex) }}</span>
            </div>
            <div class="content invite">
              <div
                v-for="(value, index) in calculateAmountOfItemsEachLevels(lvValue, lvIndex)"
                :key="index"
                class="invite-source"
              >
                <span>{{ (lvIndex * 10) + (index + 1) }}. {{ value.referrerEmail }}</span>
                <div class="claim">
                  <img src="/static/svg/reward-claim.svg">
                  <span >{{ $t('referral_program.received') }} {{ lvValue * 5 }} KUL</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <div
            v-for="(index) in 3"
            :key="index"
            class="content columns"
          >
            <div class="column">
              <b-skeleton height="30px"/>
            </div>
            <div class="column">
              <b-skeleton height="30px"/>
            </div>
          </div>
        </div>
      </div>
      <div class="title invite">
        {{ $t('referral_program.invite_friends') }}
      </div>
      <div class="section-white">
        <div class="content">
          <ReferralRules/>
        </div>
      </div>
    </div>
    <div class="referral-container--item">
      <Footer/>
    </div>
  </div>
</template>

<script>
import VueQr from 'vue-qr'
import { saveAs } from 'file-saver'
import Service from './service'
import { kulapApi } from '@/resources'
import { mapState } from 'vuex'
import cookie from '@/utils/cookie'
import Header from '@/features/Header'
import Footer from '@/components/Footer'
import ShareToSocials from '@/components/ShareToSocials'
import ReferralRules from './components/ReferralRules'
import { getBaseURL } from '@/environments'

export default {
  name: 'ReferralProgram',
  components: {
    Header,
    Footer,
    ReferralRules,
    VueQr,
    ShareToSocials
  },
  data: () => ({
    service: null,
    userReferrals: [],
    imageUrl: '',
    isLoadingUserData: false,
    isLoadingReferral: false
  }),
  computed: {
    ...mapState({
      user: state => state.user
    }),
    qrCodeFileName () {
      const displayName = this.user.displayName || ''
      return `${displayName.replace(/ /g, '_')}_qr_code_referral.png`
    },
    urlReferralLink () {
      return `${getBaseURL()}/register?ref=${this.user.referralCode}`
    },
    amountOfLevels () {
      if (Math.ceil(this.userReferrals.length / 10) > 3) {
        return 3
      } else {
        return Math.ceil(this.userReferrals.length / 10)
      }
    }
  },
  async created () {
    if (!cookie.get('user') || !cookie.get('accessToken')) {
      this.$router.push({ name: 'Login', query: { next: 'ReferralProgram' } })
      return
    }
    this.service = new Service({
      store: this.$store,
      kulapApi
    })
    this.isLoadingUserData = true
    this.isLoadingReferral = true
    await this.service.getUserProfile()
    if (!this.user.isActive) {
      this.$router.push({ name: 'Exchange' })
    }
    this.isLoadingUserData = false
    this.userReferrals = await this.service.getUserReferrals()
    this.isLoadingReferral = false
  },
  mounted () {
    const currentRoute = this.$router.currentRoute
    const idToScrollTo = currentRoute.hash
    this.$nextTick(() => {
      if (idToScrollTo && document.querySelector(idToScrollTo)) {
        document.querySelector(idToScrollTo).scrollIntoView({ behavior: 'smooth' })
      }
    })
  },
  methods: {
    onCopy () {
      this.$buefy.toast.open({
        type: 'is-success',
        message: this.$t('messages.copied')
      })
    },
    onCanNotCopy () {
      this.$buefy.toast.open({
        type: 'is-danger',
        message: this.$t('messages.can_not_copy')
      })
    },
    getImageUrl (dataUrl) {
      this.imageUrl = dataUrl
    },
    saveAs,
    isIOS () {
      return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
    },
    calculateAmountOfItemsEachLevels (lvValue, lvIndex) {
      if (lvValue < 3) {
        return this.userReferrals.slice(lvIndex * 10, lvIndex * 10 + 10)
      } else {
        return this.userReferrals.slice(lvIndex * 10)
      }
    },
    inviteEachLevels (value, index) {
      if (value !== 3) {
        return this.$t('referral_program.invited', [value * 5, index * 10 + 1, index * 10 + 10])
      } else {
        return this.$t('referral_program.invited_up', [value * 5, 21])
      }
    }
  }
}
</script>

<style lang="scss">
#referral-program-field {
  .is-underline-input-gray {
    input {
      font-size: 15px;
      &:disabled {
        background: #f0f0f0 !important;
      }
    }
  }
  /* Mobile */
  @media only screen and (max-width: 768px) {
    .is-underline-input-gray {
      input {
        font-size: 3.3vw;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.referral-container {
  float: left;
  width: 100%;
  min-height: 100vh;

  &--item {
    float: left;
    width: 100%;
  }
}
.section-gray {
  float: left;
  width: 100%;
  padding-bottom: 170px;
  text-align: center;
}
.title {
  font-size: 30px;
  font-weight: bold;
  text-align: center;
  color: #000000;
  &.referral {
    margin: 70px 0 35px 0;
  }
  &.invite {
    margin: 52px 0 40px 0;
  }
}
.section-white {
  padding: 33px 0;
  display: inline-block;
  width: 100%;
  max-width: 800px;
  border-radius: 5px;
  box-shadow: 0 2px 4px -3px rgba(0, 0, 0, 0.5);
  background-color: #ffffff;
  text-align: left;
  .content {
    padding: 0 50px;
    color: #000000;
    &.invite {
      float: left;
      padding: 20px 50px;
      width: 100%;
    }
  }
}
.breadcrumb-level {
  margin-top: 140px;
  height: 40px;
  display: inline-block;
  width: 100%;
  max-width: 1000px;
}
.pointer {
  width:100%;
  max-width: calc(100% / 3 - 27px);
  margin-right: 40px;
  height: 40px;
  position: relative;
  background: #b4b4b4;
  line-height: 40px;
  color: white;
  float: left;
  &:first-child {
    border-radius: 4px 0 0 4px;
  }
  &:last-child {
    border-radius: 0 4px 4px 0;
    margin-right: unset;
  }
  &:not(:first-child):after {
    content: "";
    position: absolute;
    left:-20px;
    bottom: 0;
    width: 0;
    height: 0;
    border-width: 20px 0 20px 20px;
    border-style: solid;
    border-color: #b4b4b4 #b4b4b4 #b4b4b4 transparent;
  }
  &:not(:last-child):before {
    content: "";
    position: absolute;
    right: -20px;
    bottom: 0;
    width: 0;
    height: 0;
    border-left: 20px solid #b4b4b4;
    border-top: 20px solid transparent;
    border-bottom: 20px solid transparent;
  }
  &.active {
    background-color: #3075ef;
    &:not(:first-child):after {
      border-color: #3075ef#3075ef #3075ef transparent;
    }
    &:not(:last-child):before {
      border-left: 20px solid #3075ef;
    }
  }
}
.sub-title {
  font-family: Roboto;
  font-size: 19px;
  font-weight: bold;
  color: #000000;
  margin-bottom: 30px;
}
.qr-code {
  font-family: Roboto;
  .subtitle {
    font-size: 15px;
    font-weight: bold;
    margin-bottom: 10px;
    &.ref {
      margin-bottom: 10px;
    }
  }
  .image {
    width: 200px;
    margin: 0 auto;
  }
  .download {
    font-size: 15px;
    color: #2193ff;
    cursor: pointer;
    font-weight: bold;
    display: block;
    text-align: center;
    margin-top: 10px;
    &:hover {
      color: #0079fd;
    }
  }
}
.share-social {
  .subtitle {
    font-size: 15px;
    font-weight: bold;
  }
  .social-wrapper {
    margin: 23px 0 45px;
  }
  .social-wrapper-skt {
    margin: 23px 0 45px;
    display: block;
  }
  .ref-url {
    color: #555555;
    .show-link {
      width: 360px;
      display: inline-block;
      vertical-align: middle;
    }
  }
  .copy-icon {
    padding-left: 10px;
    color:#bcbcbc;
    &:hover {
      color: black;
    }
  }
}
.level-header  {
  font-family: Roboto;
  height: 45px;
  width: 100%;
  padding: 13px 54px;
  float: left;
  color: white;
  background-color: #3075ef;
}
.lv-label {
  font-size: 16px;
  font-weight: bold;
  margin-right: 14px;
}
.lv-receive {
  font-size: 14px;
}
.invite-source {
  float: left;
  vertical-align: top;
  width:100%;
  max-width: 350px;
  margin-right: -4px;
  padding: 14px 5px;
  >span {
    float: left;
    font-size: 14px;
    font-weight: bold;
    width: 179px;
  }
  .claim {
    font-weight: bold;
    float: left;
    color: #7ed321;
    img {
      margin-right: 8px;
      vertical-align: middle;
    }
  }
}
/* Mobile */
@media only screen and (max-width: 768px) {
  .section-gray {
    padding-bottom: 1rem;
  }
  .breadcrumb-level {
    max-width: 95vw;
    margin-top: 10px;
    .pointer {
      .lv-label {
        margin-right: unset;
      }
      .lv-receive {
        display: none;
      }
    }
  }
  .title {
    &.referral {
      font-size: 15px;
      margin: 42px 0 19px 0;
    }
    &.invite {
      font-size: 15px;
      margin: 79px 0 29px 0;
  }
  }
  .section-white {
    max-width: 95vw;
    .content {
      padding: 0 20px;
      &.invite {
        padding: 20px 5px;
      }
    }
    .sub-title {
      font-size: 15px;
    }
  }
  .share-social {
    .ref-url {
      .ref-url {
        font-size: 11px;
      }
      .show-link {
        width: 85%
      }
    }
  }
  .level-header {
    padding: 11px 9px;
    text-align: center;
  }
  .invite-source {
    padding: 14px 20px;
    font-size: 11px;
    >span {
      font-size: 12px;
      width: 53%;
    }
    .claim {
      img {
        width: 14px;
      }
    }
  }
  .level-expand-on-mobile {
    flex-grow: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/ReferralProgram/index.vue